<template>
    <div v-if="$route.query.token" class="row justify-content-center">
        <div class="form-container d-flex flex-column align-items-center">
            <div class="card bg-transparent border-0">
                <div class="card-body">
                    <h2 class="title-text mx-auto mb-3">
                        {{ $t('title.passwordRecovery') }}
                    </h2>

                    <ValidationObserver ref="observer">
                        <v-input class="d-none" type="text" autocomplete="username" :value="mail" />

                        <v-input
                            v-model="password"
                            class="input-w-default"
                            ind="0"
                            type="password"
                            name="password"
                            :placeholder="$t('placeholder.newPassword')"
                            :icon="$getInputIcon(password, 'password')"
                            :rules="{required: true, min: 6}"
                            autocomplete="new-password"
                            @keyEnterUp="restore"
                        />

                        <v-input
                            v-model="passwordConfirm"
                            class="input-w-default"
                            ind="1"
                            type="password"
                            name="passwordConfirm"
                            :placeholder="$t('placeholder.repeatPassword')"
                            :icon="$getInputIcon(passwordConfirm, 'password')"
                            rules="required|confirmed:password"
                            autocomplete="new-password"
                            @keyEnterUp="restore"
                        />
                    </ValidationObserver>

                    <b-button class="restore-button w-75 mb-2" @click="restore">
                        {{ $t('button.restore') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import VInput from './VInput';
    import { USER_SET_STATUS } from 'mutations/user';

    export default {
        name: 'RestorePassword',

        components: {
            VInput
        },

        data() {
            return {
                password: '',
                passwordConfirm: '',
                mail: ''
            };
        },

        async created() {
            let response = await api.post('/app/mailByToken', {
                token: this.$route.query.token
            });

            if (response && response.status === this.$defines.RESPONSE_STATUS.OK)
                this.mail = response.data;
        },

        methods: {
            async restore() {
                let isValid = await this.$refs.observer.validate();

                if (isValid) {
                    let response = await api.post('/app/registration/restore', {
                        password: this.password,
                        token: this.$route.query.token
                    });

                    if (response && response.status === this.$defines.RESPONSE_STATUS.OK) {
                        await this.$store.commit(`user/${USER_SET_STATUS}`, this.$defines.AUTHORIZE_STATUS.ACCOUNT_EXISTS);
                        await this.$router.push('/account?passwordChanged=true');
                    }
                }
            }
        }
    };
</script>

<style scoped>
    .title-text {
        font-weight: lighter !important;
        font-size: 23px;
        line-height: 27px;
        text-decoration: none !important;
        padding-bottom: 2px;
        border-bottom: 1px solid #FFFFFF;
        color: white;
        text-align: center;
        text-decoration-skip-ink: none;
    }

    .restore-button {
        display: flex !important;
        flex-direction: row !important;
        justify-content: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
        background-color: transparent !important;
        border: 1px solid #36AB71 !important;
        border-radius: 5px !important;
        margin-top: 1.7rem !important;
    }

    .restore-button:hover {
        background-color: #36AB71 !important;
    }
</style>
